export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["SIMPLE_PRODUCT"] = "SimpleProduct";
    ProductTypeEnum["CONFIGURABLE_PRODUCT"] = "ConfigurableProduct";
    ProductTypeEnum["BUNDLE_PRODUCT"] = "BundleProduct";
    ProductTypeEnum["GROUPED_PRODUCT"] = "GroupedProduct";
})(ProductTypeEnum || (ProductTypeEnum = {}));
